let config = {};

export async function loadConfig() {
  try {
    const resp = await fetch('/config.json');
    if (resp.ok) {
      config = await resp.json();
    }
  } catch (e) {
    // Silently fall back to build-time env vars (local dev, or config.json missing)
  }
}

export function getBackendUrl() {
  return config.REACT_APP_BACKEND_URL
    || process.env.REACT_APP_BACKEND_URL
    || 'http://localhost:8000';
}

export function getStripeKey() {
  return config.REACT_APP_STRIPE_PUBLISHABLE_KEY
    || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    || '';
}

export function getPostHogKey() {
  return config.REACT_APP_POSTHOG_KEY
    || process.env.REACT_APP_POSTHOG_KEY
    || '';
}

export function getPostHogHost() {
  return config.REACT_APP_POSTHOG_HOST
    || process.env.REACT_APP_POSTHOG_HOST
    || 'https://us.i.posthog.com';
}
